import { site } from "../content";
import { WaCta } from "./WaCta";
import { Reveal, SectionHeading } from "./Reveal";

export default function Personalization() {
  return (
    <section id="personalizacao" data-testid="personalization-section" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <div>
            <SectionHeading
              chapter="08"
              eyebrow="Personalização"
              title="O Barber Steamer com a cara da sua barbearia."
              subtitle="O equipamento pode receber personalização com o logo da barbearia, integrando o Barber Steamer à identidade do estabelecimento."
              testId="personalization-heading"
            />
            <Reveal delay={0.2}>
              <div className="mt-10">
                <WaCta
                  message={site.messages.personalization}
                  location="personalization"
                  label="Quero personalizar o meu"
                  testId="personalization-cta"
                />
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.12}>
            <div className="relative mx-auto w-full max-w-md">
              <div className="absolute -inset-3 rounded-3xl border border-gold/20" aria-hidden="true" />
              <div className="relative overflow-hidden rounded-2xl border border-white/10 shadow-[0_32px_80px_rgba(0,0,0,0.6)]">
                <img
                  src={site.assets.cutout}
                  alt="Exemplo de Barber Steamer que pode receber personalização com o logo da barbearia"
                  loading="lazy"
                  data-testid="personalization-image"
                  className="aspect-square w-full bg-graphite/50 object-contain p-10"
                />
                <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                  <div className="flex h-36 w-36 items-center justify-center rounded-full border-2 border-dashed border-gold/80 bg-ink/55 text-center shadow-[0_0_50px_rgba(252,172,4,0.25)] backdrop-blur-sm">
                    <span className="px-4 font-display text-[11px] font-bold uppercase tracking-[0.25em] leading-relaxed text-gold">
                      Sua logo aqui
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
